// extracted by mini-css-extract-plugin
module.exports = {"root":"bj_b9","icon":"bj_cc","main-search-icon":"bj_d4","mainSearchIcon":"bj_d4","label-icon-default-filled":"bj_d5","labelIconDefaultFilled":"bj_d5"};